"use client";

import { SelectField, TextField } from "@/components/tool-kit/primitives";
import {
  BUTTON_SECONDARY,
  BUTTON_SMALL,
  CARD,
} from "@/components/tool-kit/styles";
import {
  PCR_UNIT_LABELS,
  PCR_UNITS,
  type PcrUnit,
} from "@/lib/tool-kit/biology-lab/pcr-mix";

export interface RowState {
  id: string;
  name: string;
  stock: string;
  final: string;
  unit: PcrUnit;
}

export interface RowStrings {
  name: string;
  stock: string;
  final: string;
  unit: string;
  remove: string;
  add: string;
  namePlaceholder: string;
}

/** The editable reagent list: name, stock, final concentration and the unit they share. */
export function PcrComponentRows({
  rows,
  strings,
  onChange,
  onRemove,
  onAdd,
}: {
  rows: readonly RowState[];
  strings: RowStrings;
  onChange: (id: string, patch: Partial<RowState>) => void;
  onRemove: (id: string) => void;
  onAdd: () => void;
}) {
  const unitOptions = PCR_UNITS.map((unit) => ({
    value: unit,
    label: PCR_UNIT_LABELS[unit],
  }));
  return (
    <div className="space-y-3">
      {rows.map((row) => (
        <div className={`${CARD} space-y-3`} key={row.id}>
          <div className="grid gap-3 sm:grid-cols-[2fr_1fr_1fr_1fr_auto] sm:items-end">
            <TextField
              id={`pcr-${row.id}-name`}
              label={strings.name}
              onChange={(name) => onChange(row.id, { name })}
              placeholder={strings.namePlaceholder}
              value={row.name}
            />
            <TextField
              id={`pcr-${row.id}-stock`}
              label={strings.stock}
              numeric
              onChange={(stock) => onChange(row.id, { stock })}
              value={row.stock}
            />
            <TextField
              id={`pcr-${row.id}-final`}
              label={strings.final}
              numeric
              onChange={(final) => onChange(row.id, { final })}
              value={row.final}
            />
            <SelectField
              id={`pcr-${row.id}-unit`}
              label={strings.unit}
              onChange={(unit) => onChange(row.id, { unit })}
              options={unitOptions}
              value={row.unit}
            />
            <button
              className={BUTTON_SMALL}
              onClick={() => onRemove(row.id)}
              type="button"
            >
              {strings.remove}
            </button>
          </div>
        </div>
      ))}
      <button className={BUTTON_SECONDARY} onClick={onAdd} type="button">
        {strings.add}
      </button>
    </div>
  );
}
